import { createSlice } from '@reduxjs/toolkit';
import { INVENTORY_HISTORY_DISPLAY_LIMIT } from 'pages/Products/InventoryDetailsModal/constants';
import {
  EditInventoryForm,
  InventoryDetails,
} from 'types/product/productInventoryTypes';

interface ProductInventoryState {
  InventoryModal: {
    activeInventoryIndex: number | null;
    EditKey: number | null;
    inventoryModalOpen: boolean;
    InventoryValues: EditInventoryForm;
    countSubmit: number;
    showAllValidateErrors: boolean;
    FormErrorCount: number;
  };
  InventoryDetailsModal: {
    activeInventoryDetailsIndex: number | null;
    EditKey: number | null;
    inventoryDetailsModalOpen: boolean;
    InventoryDetailsValues: InventoryDetails;
    countSubmit: number;
    showAllValidateErrors: boolean;
    FormErrorCount: number;
    PageDetails: {
      entriesPerPage: number;
      currentPage: number;
      inputPageValue: number;
    };
  };
}

export const initialState: ProductInventoryState = {
  InventoryModal: {
    activeInventoryIndex: null,
    EditKey: null,
    inventoryModalOpen: false,
    InventoryValues: {
      barcode: '',
      name: '',
      categoryName: '',
      currentQuantity: '',
      adjustQuantity: '',
      transComment: '',
    },
    countSubmit: 0,
    showAllValidateErrors: false,
    FormErrorCount: 1,
  },
  InventoryDetailsModal: {
    activeInventoryDetailsIndex: null,
    EditKey: null,
    inventoryDetailsModalOpen: false,
    InventoryDetailsValues: {
      itemIdNumber: '',
      barcode: '',
      name: '',
      quantityBalance: '',
    },
    countSubmit: 0,
    showAllValidateErrors: false,
    FormErrorCount: 0,
    PageDetails: {
      entriesPerPage: INVENTORY_HISTORY_DISPLAY_LIMIT,
      currentPage: 0,
      inputPageValue: 1,
    },
  },
};

const ProductInventorySlice = createSlice({
  name: 'ProductInventory',
  initialState,
  reducers: {
    setActiveInventoryIndex: (state, action) => {
      state.InventoryModal.activeInventoryIndex = action.payload;
    },
    setInventoryModalOpen: (state, action) => {
      state.InventoryModal.inventoryModalOpen = action.payload;
    },
    setInventoryValues: (state, action) => {
      state.InventoryModal.InventoryValues = action.payload;
    },
    setShowAllValidateInventoryErrors: (state, action) => {
      state.InventoryModal.showAllValidateErrors = action.payload;
    },
    setCountInventorySubmit: (state) => {
      state.InventoryModal.countSubmit += 1;
    },
    setInventoryFormErrorCount: (state, action) => {
      state.InventoryModal.FormErrorCount = action.payload;
    },
    setInventoryEditKey: (state, action) => {
      state.InventoryModal.EditKey = action.payload;
    },
    setActiveInventoryDetailsIndex: (state, action) => {
      state.InventoryDetailsModal.activeInventoryDetailsIndex = action.payload;
    },
    setInventoryDetailsModalOpen: (state, action) => {
      state.InventoryDetailsModal.inventoryDetailsModalOpen = action.payload;
    },
    setInventoryDetailsValues: (state, action) => {
      state.InventoryDetailsModal.InventoryDetailsValues = action.payload;
    },
    setShowAllValidateInventoryDetailsErrors: (state, action) => {
      state.InventoryDetailsModal.showAllValidateErrors = action.payload;
    },
    setCountInventoryDetailsSubmit: (state) => {
      state.InventoryDetailsModal.countSubmit += 1;
    },
    setInventoryDetailsEditKey: (state, action) => {
      state.InventoryDetailsModal.EditKey = action.payload;
    },

    setEntriesPerPage: (state, action) => {
      state.InventoryDetailsModal.PageDetails.entriesPerPage = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.InventoryDetailsModal.PageDetails.currentPage = action.payload;
      state.InventoryDetailsModal.PageDetails.inputPageValue =
        action.payload + 1;
    },
    setInputPageValue: (state, action) => {
      state.InventoryDetailsModal.PageDetails.inputPageValue = action.payload;
    },
  },
});

export const {
  setActiveInventoryIndex,
  setInventoryModalOpen,
  setInventoryValues,
  setShowAllValidateInventoryErrors,
  setCountInventorySubmit,
  setInventoryFormErrorCount,
  setInventoryEditKey,
  setActiveInventoryDetailsIndex,
  setInventoryDetailsModalOpen,
  setInventoryDetailsValues,
  setShowAllValidateInventoryDetailsErrors,
  setCountInventoryDetailsSubmit,
  setInventoryDetailsEditKey,
  setEntriesPerPage,
  setCurrentPage,
  setInputPageValue,
} = ProductInventorySlice.actions;

export default ProductInventorySlice.reducer;
